export default __webpack_public_path__ + "static/media/pumin.70effb92.webp";